/**
 * Customer Store Module
 * Handles customer profile information
 */

const state = {
  id: localStorage.getItem('customerId') || null,
  phoneNumber: localStorage.getItem('phoneNumber') || null,
  firstName: localStorage.getItem('firstName') || null,
  lastName: localStorage.getItem('lastName') || null,
  email: localStorage.getItem('email') || null,
  customerId: localStorage.getItem('customerId') || null,
  profileImage: localStorage.getItem('profileImage') || '/images/backend-graphics/default_avatar.png'
};

const mutations = {
  /**
   * Set customer information in state and localStorage
   */
  SET_CUSTOMER_INFO(state, { id, phoneNumber, firstName, lastName, email, customerId, profileImage }) {
    state.id = id;
    state.phoneNumber = phoneNumber;
    state.firstName = firstName;
    state.lastName = lastName;
    state.email = email;
    state.customerId = customerId;
    state.profileImage = profileImage || '/images/backend-graphics/default_avatar.png';

    // Update localStorage
    localStorage.setItem('id', id);
    localStorage.setItem('customerId', customerId);
    localStorage.setItem('profileImage', profileImage || '/images/backend-graphics/default_avatar.png');
    localStorage.setItem('phoneNumber', phoneNumber);
    localStorage.setItem('firstName', firstName);
    localStorage.setItem('lastName', lastName);
    localStorage.setItem('email', email);
  },

  /**
   * Clear customer information from state and localStorage
   */
  CLEAR_CUSTOMER_DATA(state) {
    state.id = null;
    state.phoneNumber = null;
    state.firstName = null;
    state.lastName = null;
    state.email = null;
    state.customerId = null;
    state.profileImage = '/images/backend-graphics/default_avatar.png';

    // Clear localStorage
    localStorage.removeItem('id');
    localStorage.removeItem('customerId');
    localStorage.removeItem('profileImage');
    localStorage.removeItem('phoneNumber');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('email');
  }
};

const actions = {
  /**
   * Update customer information
   * @param {Object} customerInfo - The customer information to update
   */
  updateCustomerInfo({ commit }, customerInfo) {
    commit('SET_CUSTOMER_INFO', customerInfo);
  },

  /**
   * Clear all customer data
   */
  clearCustomerData({ commit }) {
    commit('CLEAR_CUSTOMER_DATA');
  }
};

const getters = {
  /**
   * Get customer information
   */
  customerInfo: state => ({
    id: state.id,
    phoneNumber: state.phoneNumber,
    firstName: state.firstName,
    lastName: state.lastName,
    email: state.email,
    customerId: state.customerId,
    profileImage: state.profileImage
  }),

  /**
   * Get customer's full name
   */
  fullName: state => {
    if (state.firstName && state.lastName) {
      return `${state.firstName} ${state.lastName}`;
    } else if (state.firstName) {
      return state.firstName;
    } else if (state.email) {
      return state.email;
    } else {
      return 'Guest';
    }
  },

  /**
   * Check if customer data is loaded
   */
  isProfileLoaded: state => !!state.customerId
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 